export const DEFAULT_DAYS_FOR_HOT = 7;
